import {Component, OnInit, ViewContainerRef, Inject, ViewChild, ElementRef} from '@angular/core';
import {DataService} from "../services/data.service";
import {LoginService} from "../services/login.service";
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/operator/delay';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import 'material-design-lite/material.min.js'
import {EditDataService, Info} from "../services/edit-data.service";
import {MdDialog, MdDialogConfig, MD_DIALOG_DATA, MdDialogRef} from "@angular/material";
import {NgForm} from "@angular/forms";
@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  providers: [ToastsManager],
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
  /**
   * Review
   * Todo:
   * Слишком много переменных, возможно что-то можно объеденить в объекты
   */
  public data: any = [];
  public mainData: any = [];
  public datatable: any = [];
  public dataModal: any;
  public datapayment: any = {};
  public prolong: any = {
    SummaProlong: 0,
    DateToProlong: 0,
    SummaProcentov: null
  };
  public prolongPeriod:any;
  totalSum: number;
  periodId: number;
  email: string;
  modelInput: any = {};
  idleState = 'Not started.';
  timedOut = false;
  activity: boolean;
  show: boolean;
  isVisible: boolean;
  modal: any;
  id: number;
  cs: number;
  info: Info[];
  progress: boolean;
  errorMessage: any;
  _body: any;
  state: string = 'firstpos';
  start: any;
  unlockInactiveIndentureAfterPortmone: number;

  constructor(private idle: Idle,
              public router: Router,
              private dataService: DataService,
              private editDataService: EditDataService,
              private route: ActivatedRoute,
              public toastr: ToastsManager,
              public loginService: LoginService, vRef: ViewContainerRef,
              public dialog: MdDialog) {

    this.toastr.setRootViewContainerRef(vRef);


    this.show = false;
    this.activity = false;
    this.isVisible = false;
    idle.setIdle(1);
    idle.setTimeout(9);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onInterrupt.subscribe(() => {
      this.activity = true;
    });
    idle.onTimeout.subscribe(() => {
      this.reset();
    });
    idle.onTimeoutWarning.subscribe(() => {
      this.activity = this.activity ? true : false;
    });
    this.reset();
    this.checkActivite();

    /*if (this.id && this.cs) {*/
    /*if (this.dataService.indentureData != null) {*/
    this.dataService.getData().subscribe(
      data => {

        this.data = JSON.parse(data._body);
        if (this.data.hasOwnProperty('SetFocus')) {
          this.prolong = this.data.PeriodProlong[parseInt(this.data.SetFocus)];
          this.data.PeriodProlongId = parseInt(this.data.SetFocus);
        }
        this.id = this.data.indentureID;

        if (this.data.PeriodProlong.length > 0) { // На инициализации выбираем 0й элемент
          this.periodId = this.data.PeriodProlongId;
          this.prolong = this.data.PeriodProlong[0]
          this.totalSum = +(parseFloat(this.prolong.SummaProlong) + parseFloat(this.data.Summa)).toFixed(2);
        }

      },
      error => {
        this.errorMessage = <any>error;
        error = JSON.parse(error._body);
        this.toastr.error(error.message, error.status_code, {dismiss: 'click'});
        this.router.navigate(['/login']);
      }
    );
    /*} else {*/
    /*this.router.navigate(['/login']);*/
    /*}*/
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  checkActivite() {
    this.start = setInterval(() => {

      if (this.id) {
        this.SendActivity();
      }
      this.activity = false;
    }, 6000);
  }

  openDialog() {
    let dialogRef = this.dialog.open(TableDialogComponent, {
      width: '800px',
      data: this.data
    });
    // Material 2.0.0-beta.2 does not apply panelClass to the overlay.
    (dialogRef as any)._overlayRef.overlayElement.classList.add('period-prolong-dialog-panel');
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.periodId = this.data.PeriodProlongId;
        this.prolong = result;
        this.totalSum = +(parseFloat(this.prolong.SummaProlong) + parseFloat(this.data.Summa)).toFixed(2);
      }
    });
  }

  SendActivity() {
    this.dataService.sendActivity(this.id, this.activity)
      .subscribe(
        data => {
          data = JSON.parse(data._body);
          if (data.code === 4504) {
            this.loginService.logout();
            clearInterval(this.start);
            this.idle.stop();
          }
        },
        error => {
          error = JSON.parse(error._body);
          this.toastr.error(error.message, error.status_code, {dismiss: 'click'});
          this.loginService.logout();

          clearInterval(this.start);
          this.idle.stop();
        }
      );
  }
  periodProlong() {
    console.log(this.data.EventID);
    console.log(this.data.PeriodProlongId);
    let token = localStorage.getItem("accessToken");

    if (!token) {
      this.loginService.logout();
      clearInterval(this.start);
      this.idle.stop();
    }

    this.dataService.periodProlong(this.data.EventID, this.periodId, this.totalSum, this.modelInput.email, token)
      .subscribe(
        data => {
          this.dataService.setReceipt(data);
          this.datapayment = JSON.parse(data["_body"]);

          // Открываем диалог
          this.dialog.open(PayDialogComponent, {
            width: '720px',
            data: {
              dataPayment: this.datapayment,
              dataModal: this.dataModal,
              dataUnlockInactiveIndentureAfterPortmone: this.unlockInactiveIndentureAfterPortmone
            }
          });

          // После успешного запроса отправляем форму
          setTimeout(() => {
            const form = document.getElementById("platonPaymentForm") as HTMLFormElement;
            if (form) {
              // form.submit();
            } else {
              console.error("Форма platonPaymentForm не найдена!");
            }
          }, 500);
        },
        error => {
          error = JSON.parse(error._body);
          this.toastr.error(error.message, error.status_code, { dismiss: 'click' });
          this.router.navigate(['/login']);
        }
      );
  }


  viewChoice() {
    if (this.data.PeriodProlongId || this.data.PeriodProlongId === 0) {
      this.prolong.SummaProlong = this.data.PeriodProlong[this.data.PeriodProlongId].SummaProlong;
      this.prolong.DateToProlong = this.data.PeriodProlong[this.data.PeriodProlongId].DateToProlong;

    }
  }

  logout() {
    this.loginService.sendLogout(this.id)
      .subscribe(
        data => {
          this.loginService.logout();
          clearInterval(this.start);
          this.idle.stop();
        }
      );
  }

  ngOnInit() {

    this.editDataService.getData().subscribe(data => {
      this.unlockInactiveIndentureAfterPortmone = this.editDataService.defaultData.unlockInactiveIndentureAfterPortmone;
      this.dataModal = data;
      this.datatable = data;
    });
  }
}

/**
 * Review
 * Todo:
 * Каждый компонент в отдельном файле
 */
@Component({
  selector: 'period-prolong-dialog',
  templateUrl: './period-prolong-dialog.html',
  styleUrls: ['./order.component.scss'],
  providers: [MdDialogConfig]

})
export class TableDialogComponent {
  prolong: any;
  selectedAt: string;

  constructor(public dialogRef: MdDialogRef<TableDialogComponent>, @Inject(MD_DIALOG_DATA) public data: any,
              private dataService: DataService) {

  }

  confirmPeriod() {
    try {
      if (this.prolong) {
        this.dataService.recordProlongationConfirmation(
          this.data.EventID, this.data.PeriodProlongId, this.selectedAt, new Date().toISOString()
        ).subscribe(() => {}, () => console.error('Client payment confirmation could not be recorded'));
      }
    } catch (error) {
      console.error('Client payment confirmation could not be recorded');
    }
    this.dialogRef.close(this.prolong);
  }

  choicePeriod(idPeriod, data) {
    this.selectedAt = new Date().toISOString();
    this.data.PeriodProlongId = idPeriod;
    data.click = true;
    this.prolong = data;

  }
}

/**
 * Review
 * Todo:
 * Каждый компонент в отдельном файле
 */
@Component({
  selector: 'pay-dialog',
  templateUrl: './pay-dialog.html',
  styleUrls: ['./order.component.scss'],
  providers: [MdDialogConfig]

})
export class PayDialogComponent {
  dataModal: any;
  dataPayment: any;
  dataUnlockInactiveIndentureAfterPortmone: number;
  platonPaymentData: any;



  constructor(public dialogRef: MdDialogRef<PayDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data: any,
              private dataService: DataService) {
    this.dataModal = data.dataModal;
    this.dataPayment = data.dataPayment;
    this.dataUnlockInactiveIndentureAfterPortmone = data.dataUnlockInactiveIndentureAfterPortmone;
  }

  ngOnInit() {
    this.platonPaymentData = this.dataPayment.platonPaymentData;
  }
  submitForm() {
    const form = document.getElementById("platonPaymentForm") as HTMLFormElement;
            if (form) {
              // form.submit();
            } else {
              console.error("Форма platonPaymentForm не найдена!");
            }
  }
  onSubmit(event: Event) {
    event.preventDefault(); // Останавливаем стандартное поведение Angular
    const form = event.target as HTMLFormElement;
    form.submit(); // Отправляем форму нативным способом
  }

  // async onSubmit(e) {
  //   const button = e.target[8];
  //   const buttonTextColor = e.target[8].childNodes[0].style;
  //   try {
  //     await this.disableButton(button, buttonTextColor);
  //     console.log('start');
  //     await this.dataService.transitionToPortmone(this.dataPayment);
  //     console.log('transitionToPortmone');
  //     localStorage.clear();
  //     console.log('clearData');
  //     await this.redirectToPortmone(e);
  //     console.log('redirectToPortmone');
  //   } catch (e) {
  //     button.disabled = false;
  //     buttonTextColor.color = '#ffffff';
  //     console.log(e);
  //   }
  // }

  async disableButton(button, text) {
    button.disabled = true;
    text.color = '#444444';

    setTimeout(() => {
      button.disabled = false;
      text.color = '#ffffff';
    }, 15 * 1000);
  }

  async redirectToPortmone(e) {
    return e.target.submit();
  }

}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/order/order.component.ts